module.exports = __webpack_public_path__ + "img/cm_slc2-u.7c6b34a6.png";